// React
import React from 'react';
import {
  Col,
  Row,
  Card,
  Form,
  Label,
  Input,
  CardBody,
  CardFooter,
} from 'reactstrap';

// Containers Injection
import {
  PageWrapper,
  SelectInput,
  convertEventSelectToTarget,
} from '../../containers/componentsInjection';
import PayrollDeduction from './components/selectTable';

export const FinancialPayrollDiscountPage = ({
  history,
  createData,
  validation,
  statusOptions,
  organizations,
  payrollData,
}) => {
  return (
    <PageWrapper title="Desconto em Folha">
      <Row>
        <Col xxl={12}>
          <Card>
            <Form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <CardBody className="p-4">
                <Row>
                  <Col md={3}>
                    <div className="mb-3">
                      <Label htmlFor="statusType" className="form-label">
                        Desconto em Folha
                      </Label>
                      <div className="d-flex justify-content-between align-items-center">
                        <Col>
                          <Input
                            id="statusTypeAdd"
                            name="statusType"
                            className="me-2"
                            type="radio"
                            value={'add'}
                            onBlur={validation.handleBlur}
                            checked={validation.values.statusType === 'add'}
                            onChange={(e) => {
                              if (e.target.value === 'add') {
                                validation.handleChange({
                                  target: {
                                    name: 'statusType',
                                    value: 'add',
                                  },
                                });
                              }
                            }}
                          />
                          <Label
                            htmlFor="statusTypeAdd"
                            className="text-muted text-uppercase"
                          >
                            Inclusão
                          </Label>
                        </Col>

                        <Col>
                          <Input
                            id="statusTypeRemove"
                            name="statusType"
                            className="me-2"
                            type="radio"
                            value={'remove'}
                            onBlur={validation.handleBlur}
                            checked={validation.values.statusType === 'remove'}
                            onChange={(e) => {
                              if (e.target.value === 'remove') {
                                validation.handleChange({
                                  target: {
                                    name: 'statusType',
                                    value: 'remove',
                                  },
                                });
                              }
                            }}
                          />
                          <Label
                            htmlFor="statusTypeRemove"
                            className="text-muted text-uppercase"
                          >
                            Exclusão
                          </Label>
                        </Col>
                      </div>
                    </div>
                  </Col>

                  <Col md={3}>
                    <div className="mb-3">
                      <Label className="form-label">Período por</Label>
                      <div className="d-flex justify-content-between align-items-center">
                        <Col>
                          <Input
                            id="periodTypeSale"
                            name="periodType"
                            className="me-2"
                            type="radio"
                            value={'sale'}
                            onBlur={validation.handleBlur}
                            checked={validation.values.periodType === 'sale'}
                            onChange={(e) => {
                              if (e.target.value === 'sale') {
                                validation.handleChange({
                                  target: {
                                    name: 'periodType',
                                    value: 'sale',
                                  },
                                });
                              }
                            }}
                            disabled={validation.values.statusType === 'remove'}
                          />
                          <Label
                            htmlFor="periodTypeSale"
                            className="text-muted text-uppercase"
                          >
                            Data da Venda
                          </Label>
                        </Col>
                        <Col>
                          <Input
                            id="periodTypeCreated"
                            name="periodType"
                            className="me-2"
                            type="radio"
                            value={'created'}
                            onBlur={validation.handleBlur}
                            checked={validation.values.periodType === 'created'}
                            onChange={(e) => {
                              if (e.target.value === 'created') {
                                validation.handleChange({
                                  target: {
                                    name: 'periodType',
                                    value: 'created',
                                  },
                                });
                              }
                            }}
                            disabled={validation.values.statusType === 'remove'}
                          />
                          <Label
                            htmlFor="periodTypeCreated"
                            className="text-muted text-uppercase"
                          >
                            Data da Vigência
                          </Label>
                        </Col>
                      </div>
                    </div>
                  </Col>

                  <Col md={6} className="mb-3">
                    <div>
                      <Label for="saleAtInput" className="form-label">
                        {validation.values.statusType === 'add'
                          ? 'Período de vigência'
                          : 'Período de cancelamento'}
                      </Label>
                      <div className="d-flex justify-content-center align-items-center">
                        <Input
                          type="date"
                          id="periodStarts"
                          value={validation.values.periodStarts}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                        />

                        <span className="m-2">a</span>

                        <Input
                          type="date"
                          id="periodEnds"
                          value={validation.values.periodEnds}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                        />
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="mb-3">
                      <Label
                        htmlFor="proposalSituationInput"
                        className="form-label"
                      >
                        Situação da Proposta
                      </Label>
                      <SelectInput
                        className="form-control"
                        inputId="proposalSituationInput"
                        value={validation.values.proposalSituationInput}
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'proposalSituationInput',
                              eventInput
                            )
                          );
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'proposalSituationInput',
                              eventInput
                            )
                          );
                        }}
                        options={statusOptions}
                        placeholder="Todos"
                        invalid={
                          !!(
                            validation.touched.proposalSituationInput &&
                            validation.errors.proposalSituationInput
                          )
                        }
                      />
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="organizationInput">
                        Organização
                      </Label>
                      <SelectInput
                        multiple
                        inputId="organizationInput"
                        value={validation.values.organizationInput}
                        className="form-control"
                        onChange={(eventInput) => {
                          if (!eventInput.length) {
                            validation.handleChange(
                              convertEventSelectToTarget(
                                'organizationInput',
                                null
                              )
                            );
                          } else {
                            validation.handleChange(
                              convertEventSelectToTarget(
                                'organizationInput',
                                eventInput
                              )
                            );
                          }
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'organizationInput',
                              eventInput
                            )
                          );
                        }}
                        options={createData(organizations)}
                        placeholder="Todas"
                        invalid={
                          !!(
                            validation.touched.organizationInput &&
                            validation.errors.organizationInput
                          )
                        }
                      />
                    </div>
                  </Col>

                  <Col md={12}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="instructions">
                        Instruções
                      </Label>
                      <Input
                        id="instructions"
                        aria-multiline
                        type="textarea"
                        className="form-control"
                        onBlur={validation.handleBlur}
                        onChange={validation.handleChange}
                        value={validation.values.instructions}
                        style={{
                          height: 100,
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </CardBody>

              <CardFooter>
                <Col md={12}>
                  <div className="text-end d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-link me-3"
                      onClick={() => {
                        history.push('/relatorios');
                      }}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-primary ">
                      Consultar
                    </button>
                  </div>
                </Col>
              </CardFooter>
            </Form>
          </Card>
          <PayrollDeduction payrollData={payrollData} validation={validation} />
        </Col>
      </Row>
    </PageWrapper>
  );
};
